var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRotateLeft = function SvgRotateLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68837 6.35C8.13837 4.9 10.1284 4 12.3384 4C16.7584 4 20.3284 7.58 20.3284 12C20.3284 16.42 16.7584 20 12.3384 20C8.60837 20 5.49837 17.45 4.60837 14H6.68837C7.50837 16.33 9.72837 18 12.3384 18C15.6484 18 18.3384 15.31 18.3384 12C18.3384 8.69 15.6484 6 12.3384 6C10.6784 6 9.19837 6.69 8.11837 7.78L11.3384 11H4.33837V4L6.68837 6.35Z"
  })));
};
export default SvgRotateLeft;